var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"bordered":false}},[_c('iframe',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":"http://116.130.185.160:18081/pipe/inspect","scrolling":"auto","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }